/**
 * Asynchronously loads the component for PiecripSentimentPage
 */

import { lazyLoad } from '@utils/loadable';

export const PiecripSentimentPage = lazyLoad(
  () => import('./index'),
  (module) => module.PiecripSentimentPage
);
